import { render, staticRenderFns } from "./FareList.vue?vue&type=template&id=00d50e9d&scoped=true&"
import script from "./FareList.vue?vue&type=script&lang=js&"
export * from "./FareList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d50e9d",
  null
  
)

export default component.exports